import type { QueryClient } from "@tanstack/react-query";
import { AuthRefreshFailed } from "./fetch";

/**
 * Refetch the on-screen queries whose last attempt failed for want of a token.
 *
 * During a Keycloak outage those queries end in AuthRefreshFailed, and with
 * refetchOnWindowFocus off nothing fetches them again: the panel kept showing
 * "Retrying; your session is kept" after the session had already recovered. The
 * AuthProvider timer calls this after every refresh that resolves, which is the
 * moment a token is known to be good again. Queries that failed for any other
 * reason are left alone, and an in-flight fetch is not cancelled.
 */
export function refetchQueriesFailedOnAuth(client: Pick<QueryClient, "refetchQueries">): Promise<void> {
  return client.refetchQueries(
    { type: "active", predicate: (query) => query.state.error instanceof AuthRefreshFailed },
    { cancelRefetch: false },
  );
}
